import { Alert } from '@/gen/inventory/v1/alert_pb'
import { ListCompanyArtifactCounts } from '@/gen/inventory/v1/artifact_service_pb'
import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'
import { Control } from '@/gen/inventory/v1/control_service_pb'
import { OngoingAssessment } from '@/gen/inventory/v1/ongoing_assessment_pb'
import { Questionnaire } from '@/gen/questionnaire/v2/model_pb'

import { useFeatureFlagEnabled } from '@/lib/config/featureflag'
import { cn } from '@/lib/ui/style-helpers'

import { InherentRiskWarningAlert } from '@/pages/assessment/components/inherent-risk-warning-alert/inherent-risk-warning-alert'

import { ArtifactsCard } from './artifacts-card'
import { ControlsCard } from './controls-card'
import { IssuesCard } from './issues-card'
import { QuestionnairesCard } from './questionnaires-card'

type OverviewTabProps = {
  companyId: string
  artifactCounts?: ListCompanyArtifactCounts
  artifactCountsLoading?: boolean
  questionnaires: Questionnaire[]
  controls: Control[]
  companyStatus: CompanyStatus
  engagementModeEnabled: boolean
  assessmentScore: OngoingAssessment['score']
  alerts: Alert[]
  projectId?: string
}

export const OverviewTab = ({
  companyId,
  companyStatus,
  engagementModeEnabled,
  artifactCounts,
  artifactCountsLoading,
  questionnaires,
  controls,
  assessmentScore,
  alerts,
  projectId,
}: OverviewTabProps) => {
  const { isEnabled: isQuestionnaireModuleEnabled } =
    useFeatureFlagEnabled('questionnaire-module-v2')

  return (
    <div className='pb-8'>
      <InherentRiskWarningAlert
        companyId={companyId}
        companyStatus={companyStatus}
        engagementModeEnabled={engagementModeEnabled}
      />
      <div
        className={cn(
          'grid grid-cols-1 gap-4',
          isQuestionnaireModuleEnabled ? 'md:grid-cols-1 xl:grid-cols-3' : 'xl:grid-cols-2',
        )}
      >
        <div className='col-span-full'>
          <IssuesCard
            assessmentScore={assessmentScore}
            companyId={companyId}
            alerts={alerts}
            controls={controls}
            questionnaires={questionnaires}
          />
        </div>
        <ArtifactsCard artifactCounts={artifactCounts} isLoading={artifactCountsLoading} />
        {isQuestionnaireModuleEnabled && (
          <QuestionnairesCard companyId={companyId} questionnaires={questionnaires} />
        )}
        <ControlsCard controls={controls} projectId={projectId} />
      </div>
    </div>
  )
}
